<div class="dialog-content-wrapper">
    <mat-toolbar class="bg-primary m-0">
        <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">Firma Digital</span>
            <div class="close-button" align="end">
                <button mat-icon-button (click)="dialogRef.close()" aria-label="Close dialog">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 m-0" fusePerfectScrollbar>
        <evk-firma-digital [datosFirma]="datos" (fileEventEmitter)="guardarFirma($event)"></evk-firma-digital>
    </div>
</div>
